import { render, staticRenderFns } from "./edit-activity.vue?vue&type=template&id=31a8cbbc&scoped=true&"
import script from "./edit-activity.vue?vue&type=script&lang=js&"
export * from "./edit-activity.vue?vue&type=script&lang=js&"
import style0 from "./edit-activity.vue?vue&type=style&index=0&id=31a8cbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8cbbc",
  null
  
)

export default component.exports